<template>
  <nav :class="`${this.className} menu`">
    <ul>
      <li>
        <a @click="anchor('work')">{{ $t('menu.work') }}</a>
      </li>

      <li>
        <a @click="anchor('culture')">{{ $t('menu.culture') }}</a>
      </li>

      <li>
        <a @click="anchor('community')">{{ $t('menu.community') }}</a>
      </li>

      <li v-if="!isFooter">
        <a class="button button--rounded button--blue" href="https://boards.greenhouse.io/ebanx" target="_blank">{{ $t('menu.openings') }}</a>
      </li>
    </ul>
  </nav>
</template>

<script>
import scrollElement from "@/utils/scroll";

export default {
  name: "Menu",
  props: ["className", "isFooter"],
  methods: {
    viewOpeningTeam(team) {
      this.$store.dispatch("teams/currentTeam", team);
      this.$router.push({ name: "jobs" });

      this.$emit("toggle", { target: document.querySelector(".page-header__hamburger") });
    },

    anchor(to) {
      if (this.$router.currentRoute.name !== "home") {
        this.$router.push({ name: "home" }, () => {
          setTimeout(() => {
            this.scroll(document.getElementById(to));
          }, 800);
        });
      } else this.scroll(document.getElementById(to));

      this.$emit("toggle", { target: document.querySelector(".page-header__hamburger") });
    },

    scroll(to) {
      scrollElement(to, 1000, "easeInOutQuad");
    }
  }
};
</script>
